// extracted by mini-css-extract-plugin
export default {"list":"column_list__JHg3I"};